import {
  GET_SUPPLIERS_START,
  GET_SUPPLIERS_SUCCESS,
  GET_SUPPLIERS_ERROR,
  CLEAR_SUPPLIERS_STORE,
} from 'constants/action-types/payBills/getSuppliers';
import apiAction from 'helpers/apiAction';

export default CountryCode => dispatch =>
  dispatch(
    apiAction({
      method: 'post',
      url: '/GetSuppliers',
      data: {
        CountryCode,
      },
      onStart: () => dispatch =>
        dispatch({
          type: GET_SUPPLIERS_START,
        }),
      onSuccess: data => dispatch => {
        return dispatch({
          type: GET_SUPPLIERS_SUCCESS,
          payload: {
            suppliers: data,
          },
        });
      },
      onFailure: error => dispatch => {
        return dispatch({
          type: GET_SUPPLIERS_ERROR,
          payload: {
            error: error[0],
          },
        });
      },
    }),
  );

export const clearSuppliers = () => dispatch => {
  return dispatch({
    type: CLEAR_SUPPLIERS_STORE,
    payload: {},
  });
};
